import React from "react";

const palettes = [
  ["#f59e0b", "#ec4899"],
  ["#3b82f6", "#06b6d4"],
  ["#ef4444", "#f97316"],
  ["#8b5cf6", "#6366f1"],
  ["#10b981", "#14b8a6"],
  ["#f43f5e", "#fb7185"],
  ["#0ea5e9", "#6366f1"],
];

export function Avatar({ name = "?", size = 44, className = "" }) {
  const idx = [...name].reduce((a, c) => a + c.charCodeAt(0), 0) % palettes.length;
  const [c1, c2] = palettes[idx];
  return (
    <div
      style={{ width: size, height: size, background: `linear-gradient(135deg,${c1},${c2})`, fontSize: size * 0.42 }}
      className={`rounded-full flex items-center justify-center text-white font-bold shrink-0 font-display ${className}`}
    >
      {(name.trim()[0] || "?").toUpperCase()}
    </div>
  );
}
